export default "__VITE_ASSET__CumZNeoI__"